export const mapDebitTransferStatus = {
  Approved: 'approved',
  Cancelled: 'cancelled',
  Completed: 'completed',
  Declined: 'declined',
  Expired: 'expired',
  Failed: 'failed',
  New: 'new',
  Validated: 'validated',
  ValidationFailed: 'validationFailed',
};

export const mapTranslate = {
  pickup: 'pick_up',
  websiteorder: 'delivery',
  terminal: 'sitting',
  orderType: 'order_type',
  restaurantName: 'restaurant',
  dateAndTime: 'date_and_time',
};
